<template>
  <GraphStatistics>
    <template slot="title">
      {{ $t("management.staticticsByUserTotalAccessCount") }}
    </template>
    <template slot="excel">
      <a
        @click="downExcel()"
        href="javascript:void(0)"
        class="btn btn-secondary btn-md m-1"
        >{{ $t("common.excelDownload") }}</a
      >
    </template>
    <template slot="filter">
      <tr>
        <th>{{ $t("common.year") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.year"
            @change="setStatistics"
          >
            <option v-for="(year, index) in setUp.yearList" :key="index">
              {{ year }}
            </option>
          </select>
        </td>
        <th>{{ $t("management.userType") }}</th>
        <td>
          <select
            class="int_type01 mgt_seltype int_w_full selectInput"
            v-model="form.role"
            @change="setStatistics"
          >
            <option value="total">ALL</option>
            <option value="1">Employee</option>
            <option value="2">Dealer</option>
            <option value="3">User</option>
          </select>
        </td>
      </tr>
    </template>
    <template slot="graph">
      <div>
        <table class="list_tbl">
          <thead>
            <tr>
              <th class="mobile_row">{{ $t("management.id") }}</th>
              <th class="mobile_h">{{ $t("common.name") }}</th>
              <th class="mobile_h">{{ $t("common.userType") }}</th>
              <th class="mobile_h">{{ $t("management.countryName") }}</th>
              <th class="mobile_h">{{ $t("management.company") }}</th>
              <th class="mobile_h">{{ $t("management.userStatus") }}</th>
              <th class="mobile_h">{{ $t("management.lastLoginDatetime") }}</th>
              <th class="mobile_h">{{ $t("management.totalAccessCnt") }}</th>
            </tr>
          </thead>
          <tbody v-if="members.length != 0">
            <tr v-for="(mem, index) in members" :key="index">
              <td class="text-left">
                {{ mem.loginId }}
              </td>
              <td>
                {{ mem.userName }}
              </td>
              <td>
                {{ mem.userDiv }}
              </td>
              <td>
                {{ mem.countryName }}
              </td>
              <td>
                {{ mem.compName }}
              </td>
              <td>
                {{ mem.activeFlag }}
              </td>
              <td>{{ mem.recentLoginDatetime }}</td>
              <td>
                {{ mem.accessCnt }}
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="6">{{ $t("common.noData") }}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="members.length != 0" class="paging_nav">
        <div class="paging_nav">
          <a
            href="javascript:void(0)"
            v-if="pagingVO.startPage <= pagingVO.blockSize"
            class="page_select prev_page disabled"
            >이전페이지 이동</a
          >
          <a
            v-else
            class="page_select prev_page"
            @click="searchPage(pagingVO.startPage - pagingVO.blockSize)"
            v-bind:data-page="pagingVO.startPage - pagingVO.blockSize"
            >이전페이지 이동</a
          >
          <span
            v-for="(pages, index) in pagingVO.endPage - pagingVO.startPage + 1"
            :key="index"
          >
            <strong v-if="pagingVO.startPage + index == pagingVO.currentPage">{{
              pagingVO.startPage + index
            }}</strong>
            <a
              href="javascript:void(0)"
              v-else
              @click="searchPage(pagingVO.startPage + index)"
              >{{ pagingVO.startPage + index }}</a
            >
          </span>
          <a
            v-if="pagingVO.endPage >= pagingVO.totalPage"
            href="javascript:void(0)"
            class="page_select next_page disabled"
            >다음페이지 이동</a
          >
          <a
            v-else
            href="javascript:void(0)"
            @click="searchPage(pagingVO.endPage + 1)"
            v-bind:data-page="pagingVO.endPage + 1"
            class="page_select next_page"
            >다음페이지 이동</a
          >
        </div>
      </div>
    </template>
  </GraphStatistics>
</template>

<script>
import GraphStatistics from "@/components/management/statistics/common/GraphStatistics";
import { userStatusStatisticsData, userStatusStatisticsExcel } from "@/api/statistics";
export default {
  components: {
    GraphStatistics,
  },
  data() {
    return {
      setUp: {
        yearList: [],
      },
      form: {
        year: "",
        role: "",
        page: 1,
      },
      pagingVO: {},
      searchObj: {},
      result: {},
      members: [],
    };
  },
  async created() {
    this.setYearSelect();
    await this.setDefaultFilter();
    this.getData();
  },
  methods: {
    async getData() {
      try {
        const { data } = await userStatusStatisticsData(this.form);
        this.members = data.result;
        this.pagingVO = data.pagingVO;
      } catch (error) {
        console.log(error);
      }
    },
    searchPage(page) {
      // 페이지 클릭 시
      this.form.page = page;
      this.$store.commit("setPage", page);
      this.getData();
    },
    setStatistics() {
      this.getData();
    },
    setYearSelect() {
      var firstYear = 2021;
      var now = new Date();
      var lastYear = now.getFullYear();
      this.form.year = lastYear;

      var yearList = [];
      for (lastYear; lastYear >= firstYear; lastYear--) {
        yearList.push(lastYear);
      }
      this.setUp.yearList = yearList;
    },
    setDefaultFilter() {
      this.form.role = "total";
    },
    async downExcel() {
      let loader = this.$loading.show({});
      let result = await userStatusStatisticsExcel(this.form);
      const url = window.URL.createObjectURL(
        new Blob([result.data], { type: result.headers["content-type"] })
      );
      const link = document.createElement("a");
      link.href = url;
      link.download = "StaticticsBy_UserStatus.xls";
      link.click();
      window.URL.revokeObjectURL(url);
      loader.hide();
    },
  },
};
</script>

<style></style>
